/**
 * Given an array of promises, returns a promise that resolves true if
 * all of the inner promises resolve true.
 */
export default async (promises: Promise<boolean>[]) =>
  (await Promise.all(promises)).every(result => result === true);
